import Splide from '@splidejs/splide'

// スライダーの設定値
const BREAK_POINT = 1024
const SPLIDE_OPTIONS = {
  type: 'loop',
  mediaQuery: 'min',
  perPage: 1,
  pagination: false,
  breakpoints: {
    [BREAK_POINT]: {
      destroy: true,
    },
  },
  classes: {
    arrows: 'splide__arrows case-study-section__arrows',
  },
  i18n: {
    first: '最初のスライドに移動する',
    last: '最後のスライドに移動する',
    prev: '前のスライドに移動する',
    next: '次のスライドに移動する',
    carousel: 'スライダー',
    slideLabel: '%s枚目（%s枚中）',
  },
}

const removeSettingsFromSlider = (sliderElement) => {
  // スライダーの要素内に設定された tabindex を削除する関数
  sliderElement.querySelectorAll('[tabindex]').forEach((element) => {
    element.removeAttribute('tabindex')
  })
  // aria-labelledbyを削除する
  sliderElement.removeAttribute('aria-labelledby')
}

// ブレイクポイントをまたぐ際の処理
const handleMediaQueryChange = (mediaQuery, slider, sliderElement) => {
  if (!mediaQuery.matches) {
    // 一度destroyされるとイベントハンドラも削除されるため、ブレイクポイントを下回るたびに再設定する
    slider.on('destroy', () => removeSettingsFromSlider(sliderElement))
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sliderElement = document.querySelector('#js-case-study-slider')

  // スライダーが存在しない場合は処理を終了
  if (!sliderElement) {
    return
  }

  // スライダーの初期化
  const caseStudyCarousel = new Splide(sliderElement, SPLIDE_OPTIONS)

  // destroyイベントに、tabindexを削除する処理を追加
  caseStudyCarousel.on('destroy', () => removeSettingsFromSlider(sliderElement))

  // スライダーのマウント
  caseStudyCarousel.mount()

  // メディアクエリ設定
  const mediaQuery = window.matchMedia(`(min-width: ${BREAK_POINT}px)`)
  handleMediaQueryChange(mediaQuery, caseStudyCarousel, sliderElement) // 初回実行

  // メディアクエリの変更を監視
  mediaQuery.addEventListener('change', () => handleMediaQueryChange(mediaQuery, caseStudyCarousel, sliderElement))
})
